import { createTheme } from '@mui/material';

export const MuiTheme = createTheme({
  typography: {
    allVariants: {
      fontFamily: 'Inter',
    },
  },
  palette: {
    neutral: {
      contrastText: '#F5F7FB',
      main: '#4F4F4F',
      50: '#F5F7FB',
      100: '#E4E4E4',
      200: '#CFCFCF',
      300: '#A2A2A2',
      400: '#7D7D7D',
      500: '#4F4F4F',
      600: '#262626',
      700: '#1E2229',
      800: '#161B22',
      900: '#111827',
    },
    green: {
      contrastText: '#E0EFEA',
      main: '#47BA8F',
      50: '#E0EFEA',
      100: '#E0EFEA',
      200: '#BCD1C9',
      300: '#B3D5C8',
      400: '#86BAA6',
      500: '#47BA8F',
      600: '#00BC76',
      700: '#599F84',
      800: '#266950',
      900: '#1A4F3B',
    },
    red: {
      contrastText: '#FEE2E2',
      main: '#EE2E2E',
      50: '#FEE2E2',
      100: '#FEE2E2',
      200: '#FECACA',
      300: '#FCA5A5',
      400: '#F97070',
      500: '#EE2E2E',
      600: '#DD2525',
      700: '#BA1B1B',
      800: '#9A1A1A',
      900: '#7F1D1D',
    },
  },
});
